import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import { PrivateSEOHead } from 'components/SEOHead';
import Title from '../components/Title';
import TopAppBar from '../components/app-bar/TopAppBar';

import { CheckAuth } from '../components/CheckAuth';
import Footer from './Footer';

const MainLayoutAuth = () => {
    return (
        <CheckAuth>
            <>
            <PrivateSEOHead title="Creator Account" path="/account" />
            <Title title="Home" />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    padding: 0,
                    margin: 0,
                    minHeight: '100vh',
                    // position: "relative",
                    w: '100%',
                    // background: "blue"
                }}
            >
                <TopAppBar />
                <Outlet />
                {/* <Footer /> */}
            </Box>
            </>
        </CheckAuth>
    );
};

export default MainLayoutAuth;
